import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';

@Component({
    selector: 'app-redirect',
    template: ''
})
export class RedirectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.location.href = environment.apiUrl + this.getPath() + window.location.search;
  }

  private getPath(): string {
    const pathname = window.location.pathname;
    return pathname.substring(pathname.indexOf('/redirect') + 9);
  }
}
